
<p-confirmDialog />

<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{width: '99vw', height: '96vh', maxWidth: 'none'}"
  styleClass="details-modal"
  [dismissableMask]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false">
  
  <div *ngIf="editedProject" class="details-modal-container card">
    <!-- Navigation Tabs + Close -->
    <div class="tab-nav-container">
      <nav class="tab-nav-header" role="tablist">
        <!-- Only the tabs scroll; the buttons after this div stay pinned.
             --scrollable because 11 tabs overflow at any realistic width, so the trailing
             fade always applies here. -->
        <div class="tab-nav-tabs tab-nav-tabs--scrollable">
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'project-details'"
          (click)="setActiveTab('project-details')">
          Project Details
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'raid'"
          (click)="setActiveTab('raid')">
          RAID
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'current-week-plan'"
          (click)="setActiveTab('current-week-plan')">
          Current Week Plan
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'next-week-plan'"
          (click)="setActiveTab('next-week-plan')">
          Next Week Plan
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'milestone-plan'"
          (click)="setActiveTab('milestone-plan')">
          Milestone Plan
        </button>
        <!-- Sprint backlog. Sits after the plans because it is the work underneath them,
             not another view of the same thing. -->
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'tasks'"
          (click)="setActiveTab('tasks')">
          Tasks
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'change-log'"
          (click)="setActiveTab('change-log')">
          Change Log
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'payment-tracking'"
          (click)="setActiveTab('payment-tracking')">
          Payment Tracking
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'decision-log'"
          (click)="setActiveTab('decision-log')">
          Decision Log
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'process-checklist'"
          (click)="setActiveTab('process-checklist')">
          Process Checklist
        </button>
        <button
          type="button"
          role="tab"
          class="tab-nav-button"
          [class.active]="activeTab === 'team-allocation'"
          (click)="setActiveTab('team-allocation')">
          Team Allocation
        </button>
        </div><!-- .tab-nav-tabs -->
        <p-button
          label="Weekly Report"
          icon="pi pi-file-word"
          severity="success"
          size="small"
          styleClass="tab-nav-report-btn"
          (onClick)="downloadWeeklyReportWord()"
          pTooltip="Download Weekly Progress Report (Word)"
          tooltipPosition="bottom" />
        <button
          type="button"
          class="tab-nav-close"
          (click)="cancel()"
          aria-label="Close"
          pTooltip="Close"
          tooltipPosition="bottom">
          <i class="pi pi-times"></i>
        </button>
      </nav>

      <!-- Tab Content -->
      <div class="tab-nav-content">
        <!-- Project Details Tab -->
        <div *ngIf="activeTab === 'project-details'" class="tab-nav-panel tab-nav-panel--form">
          <div class="project-details-form form-dialog-form card-content">
            <div class="form-dialog-container">
              <!-- Row 1: Project Code, Project Name, Client, Account Manager, Project Manager -->
              <div class="form-row form-row-5">
                <div class="field">
                  <label class="form-label">Project Code</label>
                  <input pInputText [value]="editedProject.projectCode || '-'" readonly class="readonly-field" />
                </div>
                <div class="field">
                  <label class="form-label">Project Name</label>
                  <input pInputText [value]="editedProject.name" readonly class="readonly-field" />
                </div>
                <div class="field">
                  <label class="form-label">Client</label>
                  <input pInputText [value]="editedProject.clientName || '-'" readonly class="readonly-field" />
                </div>
                <div class="field">
                  <label class="form-label">Account Manager</label>
                  <input pInputText [value]="editedProject.accountManagerName || '-'" readonly class="readonly-field" />
                </div>
                <div class="field">
                  <label class="form-label">Project Manager</label>
                  <input pInputText [value]="editedProject.managerName || '-'" readonly class="readonly-field" />
                </div>
              </div>

              <!-- Row 2: Start Date, End Date, Status, Progress -->
              <div class="form-row form-row-4">
                <div class="field">
                  <label class="form-label">Start Date</label>
                  <p-datepicker
          [(ngModel)]="editedStartDate"
          [showIcon]="true"
          dateFormat="D, M d, yy"
          placeholder="Select start date..."
          [showClear]="true"
          appendTo="body"
          [showOnFocus]="false"
          [autoZIndex]="true"
          styleClass="w-full" />
                </div>
                <div class="field">
                  <label class="form-label">End Date</label>
                  <p-datepicker
          [(ngModel)]="editedEndDate"
          [showIcon]="true"
          dateFormat="D, M d, yy"
          placeholder="Select end date..."
          [showClear]="true"
          appendTo="body"
          [showOnFocus]="false"
          [autoZIndex]="true"
          styleClass="w-full" />
                </div>
                <div class="form-field form-field-status field">
        <label class="form-label">Status</label>
        <p-select
          [(ngModel)]="editedProject.status"
          [options]="statusOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select status"
          [showClear]="true"
          [virtualScroll]="false"
          appendTo="body"
          panelStyleClass="filter-dropdown-panel"
          styleClass="w-full status-select-input"
          [ngClass]="'status-' + getStatusSeverity(editedProject.status)">
          <ng-template let-option pTemplate="item">
            <div class="dropdown-item-content">
              <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
              <span class="dropdown-text">{{ option.label }}</span>
            </div>
          </ng-template>
          <ng-template let-option pTemplate="selectedItem">
            <div class="dropdown-selected-content">
              <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
              <span class="dropdown-text">{{ option.label }}</span>
            </div>
          </ng-template>
        </p-select>
                </div>
                <div class="form-field form-field-progress field">
        <label class="form-label">Progress</label>
        <p-select
          [(ngModel)]="editedProject.progress"
          [options]="progressOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select progress"
          [showClear]="true"
          [virtualScroll]="false"
          appendTo="body"
          panelStyleClass="filter-dropdown-panel"
          styleClass="w-full progress-select-input"
          [ngClass]="'progress-' + getProgressSeverity(editedProject.progress)">
          <ng-template let-option pTemplate="item">
            <div class="dropdown-item-content">
              <span class="status-badge" [ngClass]="getProgressBadgeClass(option.value)"></span>
              <span class="dropdown-text">{{ option.label }}</span>
            </div>
          </ng-template>
          <ng-template let-option pTemplate="selectedItem">
            <div class="dropdown-selected-content">
              <span class="status-badge" [ngClass]="getProgressBadgeClass(option.value)"></span>
              <span class="dropdown-text">{{ option.label }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

              <!-- Row 3: Project Schedule, Deliverables, Plan to Backtrack (one line) -->
              <div class="form-row form-row-3">
                <div class="field">
                  <label class="form-label">Project Schedule</label>
                  <textarea
                    pInputText
                    [(ngModel)]="editedProject.projectSchedule"
                    placeholder="Enter project schedule..."
                    class="compact-textarea"></textarea>
                </div>

                <div class="field">
                  <label class="form-label">Deliverables</label>
                  <textarea
                    pInputText
                    [(ngModel)]="editedProject.deliverables"
                    placeholder="Enter deliverables..."
                    class="compact-textarea"></textarea>
                </div>

                <div class="field">
                  <label class="form-label">Plan to Backtrack</label>
                  <textarea
                    pInputText
                    [(ngModel)]="editedProject.planToBacktrack"
                    placeholder="Enter plan to backtrack..."
                    class="compact-textarea"></textarea>
                </div>
              </div>

              <!-- Comments: single full-width row (more space for large content) -->
              <div class="form-row form-row-1">
                <div class="field">
                  <label class="form-label">Comments and Actions</label>
                  <textarea
                    pInputText
                    [(ngModel)]="editedProject.commentsAndActions"
                    placeholder="Enter comments and actions..."
                    class="compact-textarea compact-textarea--xl"></textarea>
                </div>
              </div>

              <!-- Row 4: Effort Utilization -->
              <div class="form-row form-row-3">
                <div class="field">
                  <label class="form-label">Planned Estimate (Days)</label>
                  <input
                    pInputText
                    type="number"
                    [(ngModel)]="editedProject.plannedEstimateDays"
                    placeholder="Enter planned estimate in days..."
                    step="0.01"
                    min="0" />
                </div>

                <div class="field">
                  <label class="form-label">Actual Effort (Days)</label>
                  <input
                    pInputText
                    [value]="getActualEffortDisplay()"
                    readonly
                    class="readonly-field" />
                </div>

                <div class="field">
                  <label class="form-label">Remaining Effort (Days)</label>
                  <input
                    pInputText
                    [value]="getRemainingEffort()"
                    readonly
                    class="readonly-field" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- RAID Tab -->
        <div *ngIf="activeTab === 'raid'" class="tab-nav-panel tab-nav-panel--fill">
          <app-raid [projectId]="editedProject.id || ''"></app-raid>
        </div>

        <!-- Current Week Plan Tab -->
        <div *ngIf="activeTab === 'current-week-plan'" class="tab-nav-panel tab-nav-panel--fill">
          <app-current-week-plan [projectId]="editedProject.id || ''"></app-current-week-plan>
        </div>

        <!-- Next Week Plan Tab -->
        <div *ngIf="activeTab === 'next-week-plan'" class="tab-nav-panel tab-nav-panel--fill">
          <app-next-week-plan [projectId]="editedProject.id || ''"></app-next-week-plan>
        </div>

        <!-- Milestone Plan Tab -->
        <div *ngIf="activeTab === 'milestone-plan'" class="tab-nav-panel tab-nav-panel--fill">
          <app-milestone-plan [projectId]="editedProject.id || ''"></app-milestone-plan>
        </div>

        <!-- Tasks Tab -->
        <div *ngIf="activeTab === 'tasks'" class="tab-nav-panel tab-nav-panel--fill">
          <app-project-tasks [projectId]="editedProject.id || ''"></app-project-tasks>
        </div>

        <!-- Change Log Tab -->
        <div *ngIf="activeTab === 'change-log'" class="tab-nav-panel tab-nav-panel--fill">
          <app-change-log [projectId]="editedProject.id || ''"></app-change-log>
        </div>

        <!-- Payment Tracking Tab -->
        <div *ngIf="activeTab === 'payment-tracking'" class="tab-nav-panel tab-nav-panel--fill">
          <app-payment-tracking [projectId]="editedProject.id || ''"></app-payment-tracking>
        </div>

        <!-- Decision Log Tab -->
        <div *ngIf="activeTab === 'decision-log'" class="tab-nav-panel tab-nav-panel--fill">
          <app-decision-log [projectId]="editedProject.id || ''"></app-decision-log>
        </div>

        <!-- Process Checklist Tab -->
        <div *ngIf="activeTab === 'process-checklist'" class="tab-nav-panel tab-nav-panel--fill">
          <app-project-checklist
            [projectId]="editedProject.id || ''"
            (dirtyChange)="onChecklistDirtyChange($event)"></app-project-checklist>
        </div>

        <!-- Team Allocation Tab (read-only; managed on the Allocation Plan page) -->
        <div *ngIf="activeTab === 'team-allocation'" class="tab-nav-panel tab-nav-panel--fill">
          <app-team-allocation-month
            [projectId]="editedProject.id || ''"
            [projectName]="editedProject.name || ''"></app-team-allocation-month>
        </div>

        <!-- Footer with Cancel and Save — lives inside the scroll area, directly
             after the Project Details form, so there is no stretched empty gap
             between the form and the buttons. Only shown on the editable tab. -->
        <div *ngIf="activeTab === 'project-details'" class="form-dialog-footer-btns dialog-actions">
          <!-- Pushed to the left of Cancel/Save: it leaves this dialog rather than acting
               on it, so it does not belong in the confirm/commit pair on the right. -->
          <p-button
            label="Open in Inventory"
            icon="pi pi-external-link"
            (onClick)="openInInventory()"
            severity="secondary"
            [text]="true"
            [disabled]="isSaving"
            styleClass="dialog-actions-left"
            pTooltip="Edit this project in the Project Inventory"
            tooltipPosition="top" />
          <p-button
            label="Cancel"
            icon="pi pi-times"
            (onClick)="cancel()"
            severity="secondary"
            [outlined]="true"
            [disabled]="isSaving" />
          <p-button
            label="Save"
            icon="pi pi-check"
            (onClick)="saveProject()"
            severity="primary"
            [loading]="isSaving"
            [disabled]="isSaving" />
        </div>
      </div>
    </div>
  </div>

</p-dialog>

